import { computed, ComputedRef, ref, unref } from 'vue';

export function useLoading(props: ComputedRef<{ loading?: boolean }>) {
  const loadingRef = ref(unref(props).loading);

  const getLoading = computed(() => unref(loadingRef));

  function setLoading(loading: boolean) {
    loadingRef.value = loading;
  }

  return { getLoading, setLoading };
}
